
import * as NavConst from '../constants/NavigationConstants';
import * as SweetAlert from '../common/utilities/ConfirmationAlert';
import * as ApiConst from '../../api/ApiConst';

export const TableColumns = (columnObject) => {
  switch (columnObject.toUpperCase()) {
    case "TABLE":
      return [
        { name: "Name", value: "name", type: "STRING", i: 0, },
        { name: "Description", value: "description", type: "STRING", i: 1, },
        { name: "Created At", value: "createdAt", type: "DATETIME", i: 2, },
        {
          name: "Actions",
          value: [
            { name: "View", iconClass: "fa fa-eye", type: "navigate", navigatePath: NavConst.VIEW_TABLE_DATA, replaceData: ":viewTableName" },
            { name: "Edit", iconClass: "fa fa-edit", type: "navigate", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
            {
              name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
              navigatePath: ApiConst.getApiPath(ApiConst.DYNAMIC_TABLE, ApiConst.DELETE), replaceData: "{recordId}"
            },
            { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
            { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
          ],
          type: "",
          i: 3,
        },
      ];

    case "TABLE_ATTRIBUTE":
      return [
        { name: "Name", value: "name", type: "STRING", i: 0, },
        { name: "Type", value: "type", type: "STRING", i: 1, },
        { name: "Length", value: "attributeLength", type: "int", i: 2, },
        { name: "Null Value", value: "nullValue", type: "BOOLEAN", i: 3, },
        { name: "Auto Increment", value: "autoIncrement", type: "BOOLEAN", i: 4, },
        { name: "Comment", value: "comment", type: "STRING", i: 5, },
        {
          name: "Actions",
          value: [
            { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_REQUEST_STRUCTURE, replaceData: ":updateRequestName" },
            {
              name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
              navigatePath: ApiConst.getApiPath(ApiConst.DYNAMIC_TABLE_ATTRIBUTE, ApiConst.DELETE), replaceData: "{recordId}"
            },
            { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
            { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
          ],
          type: "",
          i: 6,
        },
      ];

    case "REQUEST":
      return [
        { name: "Name", value: "name", type: "STRING", i: 0, },
        { name: "Type", value: "type", type: "STRING", i: 1, },
        { name: "Description", value: "description", type: "STRING", i: 2, },
        { name: "Created At", value: "createdAt", type: "DATETIME", i: 3, },
        {
          name: "Actions",
          value: [
            { name: "View", iconClass: "fa fa-eye", type: "navigate", navigatePath: NavConst.DYNAMIC_REQUEST_VIEW, replaceData: ":requestId" },
            { name: "Edit", iconClass: "fa fa-edit", type: "navigate", navigatePath: NavConst.UPDATE_REQUEST_STRUCTURE, replaceData: ":updateRequestName" },
            {
              name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
              navigatePath: ApiConst.getApiPath(ApiConst.GENERIC_REQUEST, ApiConst.DELETE), replaceData: "{recordId}"
            },
            { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
            { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
          ],
          type: "",
          i: 4,
        },
      ];

    case "REQUEST_PARAMETER":
      return [
        { name: "Name", value: "name", type: "STRING", i: 0, },
        { name: "Description", value: "description", type: "STRING", i: 1, },
        { name: "Type", value: "type", type: "STRING", i: 2, },
        { name: "Required", value: "required", type: "BOOLEAN", i: 3, },
        {
          name: "Actions",
          value: [
            // { name: "Validation", iconClass: "fa-solid fa-plus", type: "navigate", navigatePath: NavConst.VIEW_SINGLE_PARAMETER_VALIDATION_LIST, replaceData: ":requestName/:parameterName" },
            { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
            {
              name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
              navigatePath: ApiConst.getApiPath(ApiConst.GENERIC_REQUEST_PARAMETER, ApiConst.DELETE), replaceData: "{recordId}"
            },
            { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
            { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
          ],
          type: "",
          i: 4,
        },
      ];

      case "RESPONSE_PARAMETER":
        return [
          { name: "Name", value: "name", type: "STRING", i: 0, },
          { name: "Type", value: "type", type: "STRING", i: 1, },
          { name: "Comment", value: "comment", type: "STRING", i: 2, },
          { name: "Path To Table Attribute", value: "pathToTableAttribute", type: "STRING", i: 3, },
          { name: "Aggregate Column", value: "aggregateColumn", type: "BOOLEAN", i: 4, },
          { name: "Path To GroupBy", value: "pathToGroupBy", type: "STRING", i: 5, },
          { name: "Aggregate Operation", value: "aggregateOperation", type: "STRING", i: 6, },

          {
            name: "Actions",
            value: [
              { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
              {
                name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
                navigatePath: ApiConst.getApiPath(ApiConst.GENERIC_RESPONSE_PARAMETER, ApiConst.DELETE), replaceData: "{recordId}"
              }
            ],
            type: "",
            i: 7,
          },
        ];

    case "COMMAND":
      return [
        { name: "Name", value: "name", type: "STRING", i: 0, },
        { name: "Value", value: "value", type: "STRING", i: 1, },
        { name: "Type", value: "type", type: "STRING", i: 2, },
        { name: "Created At", value: "createdAt", type: "DATETIME", i: 3, },
        {
          name: "Actions",
          value: [
            { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_REQUEST_STRUCTURE, replaceData: ":updateRequestName" },
            {
              name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
              navigatePath: ApiConst.getApiPath(ApiConst.MONGO_COMMANDS, ApiConst.DELETE), replaceData: "{recordId}"
            },
            { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
            { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
          ],
          type: "",
          i: 4,
        },
      ];

    case "PARAMETER_VALIDATION":
      return [
        { name: "Name", value: "name", type: "STRING", i: 0, },
        { name: "Description", value: "description", type: "STRING", i: 1, },
        { name: "Type", value: "type", type: "STRING", i: 2, },
        { name: "Message", value: "message", type: "STRING", i: 3, },
        {
          name: "Actions",
          value: [
            { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
            {
              name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
              navigatePath: ApiConst.getApiPath(ApiConst.GENERIC_VALIDATION, ApiConst.DELETE), replaceData: "{recordId}"
            },
            { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
            { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
          ],
          type: "",
          i: 4,
        },
      ];
      break;

    case "CLIENT":
      return [
        { name: "Name", value: "clientName", type: "STRING", i: 0, },
        { name: "IP", value: "ipAddress", type: "STRING", i: 1, },
        { name: "Primary Db", value: "primaryDbDetail", type: "STRING", i: 2, },
        { name: "Secondary Db", value: "secondaryDbDetail", type: "STRING", i: 3, },
        { name: "Backup Db", value: "backUpDbDetail", type: "STRING", i: 4, },
        {
          name: "Actions",
          value: [
            { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.VIEW_SELECTED_CLIENT_DATA, replaceData: "{clientId}" },
            { name: "Delete", iconClass: "fa fa-trash", type: "alert",
             action: (url,refresh) => SweetAlert.isDeleteRecord(url,refresh),
             navigatePath:ApiConst.getApiPath(ApiConst.CLIENT,ApiConst.DELETE), replaceData: "{recordId}" },
            { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
            { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
          ],
          type: "",
          i: 5,
        },
      ];
      break;
    default:
      break;
  }
}